// extracted by mini-css-extract-plugin
export default {"btop":"_19ba457941 b4ada51905 _3fe5fee092","icon":"b78c676253 a5a96104ce","btoppink":"d09434d62e _6bf469c868"};